import * as Styled from './mini-badge.styles';
import type { MiniBadgeProps } from './mini-badge.types';

export const MiniBadge = ({
  className,
  ...props
}: MiniBadgeProps): JSX.Element => (
  <Styled.MiniBadge className={className} data-xds="MiniBadge" {...props} />
);

MiniBadge.displayName = 'MiniBadge';
